import Frame from './frame';

export default Frame;